import styled from 'styled-components';

import { IconCheck } from '../../../common/icons/cdl/Check';
import { theme } from '../../../common/ui/theme';

interface SupplierSelectionIndicatorProps {
    selected: boolean;
    disabled?: boolean;
}

const Checkmark = styled.span<{ $disabled?: boolean; $selected?: boolean }>`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 999px;
    transform: scale(${(props) => (props.$selected ? 1 : 0.9)});
    filter: ${(props) => {
        if (props.$disabled) {
            return 'none';
        }

        return props.$selected ? 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.12))' : 'none';
    }};
    transition:
        filter 120ms cubic-bezier(0.2, 0.8, 0.2, 1),
        transform 120ms cubic-bezier(0.2, 0.8, 0.2, 1);
`;

const CheckmarkFill = styled.span<{ $disabled?: boolean; $selected?: boolean }>`
    box-sizing: border-box;
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: ${(props) => {
        if (props.$disabled) {
            return props.$selected ? theme.colors.background.muted : theme.colors.background.default;
        }

        return props.$selected
            ? `linear-gradient(0deg, ${theme.colors.accent.emphasis}, ${theme.colors.accent.emphasis}, ${theme.colors.effects.accentGradientStop})`
            : theme.colors.background.inset;
    }};
    transition: background 120ms cubic-bezier(0.2, 0.8, 0.2, 1);
`;

const CheckmarkIcon = styled(IconCheck)<{ $selected?: boolean }>`
    position: relative;
    color: ${theme.colors.foreground.onEmphasis};
    opacity: ${(props) => (props.$selected ? 1 : 0)};
    transform: scale(${(props) => (props.$selected ? 1 : 0.35)});
    transition:
        opacity 110ms ease-out,
        transform 160ms cubic-bezier(0.16, 1, 0.3, 1);
`;

export const SupplierSelectionIndicator = ({ selected, disabled }: SupplierSelectionIndicatorProps) => {
    return (
        <Checkmark $disabled={disabled} $selected={selected} aria-hidden="true">
            <CheckmarkFill $disabled={disabled} $selected={selected} />
            <CheckmarkIcon width={20} height={20} $selected={selected} />
        </Checkmark>
    );
};
